import React from 'react';

import {NotificationsUnsubscribeScreen} from 'features/auth';

const NotificationsUnsubscribePage: React.FC = () => {
    return <NotificationsUnsubscribeScreen/>;
};

export default NotificationsUnsubscribePage;
